import React, { useEffect, useRef } from 'react';

/** Curseur personnalisé : point + anneau en retard. Masqué au tactile et en reduced-motion. */
const Cursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    const fine = window.matchMedia('(pointer: fine)').matches;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduced) return undefined;

    document.body.classList.add('has-custom-cursor');

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ringPos = { ...pos };
    let frame;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
        dot.current.classList.add('is-ready');
        ring.current?.classList.add('is-ready');
      }
      const interactive = e.target.closest(
        'a, button, [data-cursor="link"], input, textarea'
      );
      ring.current?.classList.toggle('is-active', Boolean(interactive));
    };

    const loop = () => {
      ringPos.x += (pos.x - ringPos.x) * 0.15;
      ringPos.y += (pos.y - ringPos.y) * 0.15;
      if (ring.current) {
        ring.current.style.transform = `translate(${ringPos.x}px, ${ringPos.y}px)`;
      }
      frame = requestAnimationFrame(loop);
    };

    window.addEventListener('mousemove', onMove);
    frame = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(frame);
      document.body.classList.remove('has-custom-cursor');
    };
  }, []);

  return (
    <div aria-hidden="true">
      <span className="cursor-dot" ref={dot} />
      <span className="cursor-ring" ref={ring} />
    </div>
  );
};

export default Cursor;
